import styled from 'styled-components';

export const StyledRoomTagsBox = styled.div<{ isDarkMode: boolean }>`
  padding: 1.8rem;
  border-radius: ${({ theme }) => theme.radius.small};
  background-color: ${({ theme, isDarkMode }) => (isDarkMode ? theme.colors.secondary.light : theme.colors.grey[100])};
  margin-bottom: 1.6rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
export const StyledEmptyStateText = styled.span`
  font-size: ${({ theme }) => theme.fonts.sizes.small};
  color: ${({ theme }) => theme.colors.text.main};
`;

export const StyledTagText = styled.span`
  font-size: ${({ theme }) => theme.fonts.sizes.small};
  color: ${({ theme }) => theme.colors.text.main};
`;

export const StyledSelectedTagsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1.2rem;
  flex-wrap: wrap;
  justify-content: center;
`;
